import { Box } from '@mui/material';
import { colors, Typography } from '@sweep-io/sweep-design';
import Stack from '@mui/material/Stack';
import { AutomationVersionHistoryData } from './types';
import { TruncatedTextTooltip } from '../../common/TruncatedTextTooltip';
import { AutomationTemplate } from '../../documentation/dependencies/latest-deployed/templates/AutomationTemplate';
import { DedupAndMatchingTemplate } from '../../documentation/dependencies/latest-deployed/templates/DedupAndMatchingTemplate';
import { AutomationType } from '../../../types/enums/AutomationType';
import { Button } from '@sweep-io/sweep-design';
import { DeployStatusForTable } from '../../../types/enums/DeployStatusForTable';
import { ReadOnlyDedupMatching } from '@server/read-only-elements.types';
import { automationTypeToSweepElementType } from '../../documentation/types';

interface ReadOnlySectionProps {
  activeRow: string;
  originalVersionList: AutomationVersionHistoryData[];
  currentVersion?: AutomationVersionHistoryData;
  isDedupeOrMatching: boolean;
  automationType: AutomationType;
  handleSetAsDraft: () => void;
}

export const ReadOnlySection = ({
  activeRow,
  originalVersionList,
  currentVersion,
  isDedupeOrMatching,
  automationType,
  handleSetAsDraft,
}: ReadOnlySectionProps) => {
  return (
    <Box
      sx={{
        minWidth: '456px',
        width: '456px',
        height: '100%',
        backgroundColor: colors.grey[100],
        borderLeft: `1px solid ${colors.grey[300]}`,
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        p: '16px 24px 24px',
        overflow: 'hidden',
      }}
    >
      <Typography variant="body" color={colors.grey[700]}>
        {activeRow && originalVersionList.length > 0 ? (
          <Stack direction="row" alignItems="center" gap={0.5} overflow="hidden" minWidth={0}>
            Showing{'  '}
            <Typography variant="body-medium" color={colors.grey[900]} whiteSpace="nowrap">
              "{currentVersion?.versionName ?? 'Draft'}"
            </Typography>
            <Stack direction="row" alignItems="center" overflow="hidden" minWidth={0}>
              [
              <TruncatedTextTooltip variant="body-medium" color={colors.grey[900]}>
                {currentVersion?.name}
              </TruncatedTextTooltip>
              ]
            </Stack>
          </Stack>
        ) : (
          'Version details will be displayed here'
        )}
      </Typography>
      <Box
        sx={{
          height: '100%',
          width: '100%',
          backgroundColor: colors.white,
          borderRadius: '8px',
          border: `1px solid ${colors.grey[300]}`,
          p: 2,
          overflow: 'auto',
        }}
      >
        {!isDedupeOrMatching && (
          <AutomationTemplate
            isRemoveName={true}
            elementType={automationTypeToSweepElementType(automationType)}
            readOnlyVersion={currentVersion?.readVersion as ReadOnlyAutomation}
          />
        )}

        {isDedupeOrMatching && (
          <DedupAndMatchingTemplate
            elementType={automationTypeToSweepElementType(automationType)}
            readOnlyVersion={currentVersion?.readVersion as ReadOnlyDedupMatching}
          />
        )}
      </Box>
      {!currentVersion?.isLive && (
        <Box>
          <Button
            onClick={handleSetAsDraft}
            startIconName=""
            variant="outlined"
            disabled={!activeRow}
          >
            {currentVersion?.status === DeployStatusForTable.Draft
              ? 'Edit draft'
              : 'Restore as draft'}
          </Button>
        </Box>
      )}
    </Box>
  );
};
